exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.media-page-header[data-v-3c2084fa] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: baseline;\r\n      -ms-flex-align: baseline;\r\n          align-items: baseline;\r\n  margin-bottom: 14px;\n}\n.media-page-title[data-v-3c2084fa] {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  margin-right: 12px;\n}\n.media-page-tip[data-v-3c2084fa] {\r\n  color: #999;\r\n  font-size: 12px;\n}\r\n", ""]);

// exports
